import { render } from "./AddWebsite.vue?vue&type=template&id=263500a8&scoped=true"
import script from "./AddWebsite.vue?vue&type=script&lang=js"
export * from "./AddWebsite.vue?vue&type=script&lang=js"

import "./AddWebsite.vue?vue&type=style&index=0&id=263500a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-263500a8"]])

export default __exports__